<template>

    <div class="container">

<h1>Anuncios Generales</h1>

        <div class="coloumns">
            <div class="coloumn">
                <div class="message" v-for="(status,id) in statuses" :key="id">

                    <div class="message-header">
                        <p style="text-transform: capitalize;">{{ status.user.name }} dijo...</p>

                        <p :title="status.created_at | fechaMoment">
                            {{ status.created_at | ago | capitalize }}
                        </p>
                    </div>
                    <div class="message-body">
                        <p>
                            {{ status.body }}
                        </p>
                    </div>
                </div>

                <!-- Agregar nuevo estado -->

                <agregar-nuevo-estado
                    v-if="!esAnonimo && !esCliente"
                    @completed="agregarNuevoEstado"
                ></agregar-nuevo-estado>
            </div>
        </div>
    </div>


</template>


<script>
import moment from "moment";
moment.locale(window.navigator.userLanguage || window.navigator.language);

import Status from "../models/Status";

import AgregarNuevoEstado from "../components/AgregarNuevoEstado.vue";



export default {
    components: {
        AgregarNuevoEstado
    },

    data() {
        return {
            statuses: []
        };
    },
    mounted() {
        // ajax para buscar los estados
        Status.all(datazzz => (this.statuses = datazzz));

    },

    computed: {
        esAnonimo() {
            return document.querySelector("#perfilUsuario") == null;
        },

        esCliente() {
            let o = document.querySelector("#perfilUsuario");

            return (
                !this.esAnonimo &&
                o != null &&
                o.innerText.startsWith("CLIENTE")
            );
        }
    },

    methods: {
        postedOn(status) {
            return moment(status.created_at).fromNow();
        },

        agregarNuevoEstado(estado) {
            this.statuses.unshift(estado);

            //TODO: Usar la notificación de bulma en el template
            alert("Se ha agregado el estado");

            window.scrollTo(0, 0);
        }
    },
    filters: {
        ago(datez) {
            return moment(datez).fromNow();
        },

        capitalize(txt) {
            return txt.toUpperCase();
        },
        fechaMoment(fechaMoment) {
            return moment(fechaMoment).toLocaleString();
        }
    }
};
</script>
